export default ({
    NoAccess: 1,
    ClubAdmin: 2,
    DistrictAdmin: 3,
    //ZoneAdmin: 4, // inactive
    //CountryAdmin: 5, // inactive
    //GlobalAdmin: 6, //inactive
    SysAdmin: 7,
    MultiDistrictAdmin: 8,
});